export default "__VITE_ASSET__G3znFpFa__"